import LoginPage from '../pages/login/index.page'

import StatisticalReportPage from '../pages/system-management/statistics-report'

import { Navigate } from 'react-router-dom'

import BookListPage from '../pages/book-management/book-list/index.page'
import DetailAccountPage from '../pages/account-managment/account-list/detail.page'
import DetailGuestAccountPage from '../pages/account-managment/account-guest/detail.page'
import AccountListPage from '../pages/account-managment/account-list/index.page'
import CreateGuestAccountPage from '../pages/account-managment/account-guest/create.page'
import GuestAccountListPage from '../pages/account-managment/account-guest/index.page'
import CreateBookPage from '../pages/book-management/book-list/create.page'

import NotFoundPage from '../pages/error/NotFoundPage'
// import AdminPermissionPage from '../pages/system-management/admin-permission/index.page'
import ErrorReportPage from '../pages/system-management/error-report/index.page'
import AdminPermissionTestPage from '../pages/system-management/admin-permission/test.page'
import EditGuestAccountPage from '../pages/account-managment/account-guest/edit.page'
import EditBookPage from '../pages/book-management/book-list/edit.page'
import BookPackagePage from '../pages/book-management/book-package/index.page'
import BookPackageBooksPage from '../pages/book-management/book-package/detail.books.page'
import BookBorrow from '../pages/book-management/book-borrow/index.page'
import UsersListPerBorrowBook from '../pages/book-management/book-borrow/accountperbook.page'
import DetailAccountAdminPage from '../pages/system-management/admin-permission/detail.page'
export const PATH = {
  HOME: '/',
  BOOK: {
    LIST: '/info-book',
    UPLOAD: '/upload-book',
    PACKAGE: '/book-package',
    PACKAGE_BOOKS: (uuid) => {
      return uuid ? `/book-package/${uuid}/books` : '/book-package/:uuid/books'
    },
    UPLOAD_SINGLE: '/upload-book-form',
    EDIT: (uuid) => {
      return uuid ? `/info-book/edit/${uuid}` : '/info-book/edit/:uuid'
    },
    BORROW: '/book-borrow',
    BORROWERS_PER_BOOK: (uuid) => {
      return uuid ? `/book-borrow/${uuid}` : `/book-borrow/:uuid`
    },
  },
  ACCOUNT: {
    LIST: '/info-account',
    DETAIL: (uuid) => {
      return uuid ? `/info-account/${uuid}` : '/info-account/:uuid'
    },
    UPLOAD: '/upload-account',
    // EDIT: (uuid) => {
    //   return uuid ? `/info-account/edit/${uuid}` : '/info-account/edit/:uuid'
    // },
    // CREATE: '/info-account/create',
    GUEST: {
      LIST: '/info-guest-account',
      CREATE: '/info-guest-account/create',
      DETAIL: (uuid) => {
        return uuid
          ? `/info-guest-account/${uuid}`
          : '/info-guest-account/:uuid'
      },
      EDIT: (uuid) => {
        return uuid
          ? `/info-guest-account/edit/${uuid}`
          : '/info-guest-account/edit/:uuid'
      },
    },
  },
  SYSTEM: {
    STATISTICAL_REPORT: {
      LIST: '/statistical-report',
    },
    ERRORS_REPORT: { LIST: '/errors-report' },
    DECENTRALIZE_ADMINISTRATION: { LIST: '/decentralize-administration' },
    DETAIL: (uuid) => {
      return uuid
        ? `/decentralize-administration/${uuid}`
        : '/decentralize-administration/:uuid'
    },
  },
  LOGIN: '/login',
}

export const public_routes = [
  { path: PATH.LOGIN, element: <LoginPage /> },
  { path: '*', element: <Navigate to={PATH.LOGIN} />, title: 'Redirect' },
]

export const protected_routes = [
  { path: PATH.LOGIN, element: <LoginPage /> },
  { path: PATH.HOME, element: <></> },

  // books
  { path: PATH.BOOK.LIST, element: <BookListPage /> },
  { path: PATH.BOOK.PACKAGE, element: <BookPackagePage /> },
  { path: PATH.BOOK.PACKAGE_BOOKS(), element: <BookPackageBooksPage /> },
  { path: PATH.BOOK.UPLOAD_SINGLE, element: <CreateBookPage /> },
  { path: PATH.BOOK.EDIT(), element: <EditBookPage /> },
  { path: PATH.BOOK.BORROW, element: <BookBorrow /> },
  {
    path: PATH.BOOK.BORROWERS_PER_BOOK(),
    element: <UsersListPerBorrowBook />,
  },

  // account
  { path: PATH.ACCOUNT.LIST, element: <AccountListPage /> },
  { path: PATH.ACCOUNT.DETAIL(), element: <DetailAccountPage /> },
  { path: PATH.ACCOUNT.GUEST.LIST, element: <GuestAccountListPage /> },
  { path: PATH.ACCOUNT.GUEST.CREATE, element: <CreateGuestAccountPage /> },
  { path: PATH.ACCOUNT.GUEST.DETAIL(), element: <DetailGuestAccountPage /> },
  { path: PATH.ACCOUNT.GUEST.EDIT(), element: <EditGuestAccountPage /> },

  // system
  { path: PATH.SYSTEM.ERRORS_REPORT.LIST, element: <ErrorReportPage /> },
  {
    path: PATH.SYSTEM.DECENTRALIZE_ADMINISTRATION.LIST,
    element: <AdminPermissionTestPage />,
  },
  { path: PATH.SYSTEM.DETAIL(), element: <DetailAccountAdminPage /> },
  {
    path: PATH.SYSTEM.STATISTICAL_REPORT.LIST,
    element: <StatisticalReportPage />,
  },
  { path: '*', element: <NotFoundPage /> },
]
